import parts, { ColorMaterialInformation } from '../../colors/components'
import {Color, COLOR_ORDER} from '../../colors/colors'
import { Material, MATERIALS_ORDER } from '@/colors/materials'
import Honeybadger from 'honeybadger-js'

/**
 * ShareLinkFormat Documentation
 * * information for every component is split by a ";"
 * * a component can be defined with a material and a color
 * * for now we assume 
 *     less than 10 materials in the future
 *      and less than 36 colors
 * * a single-digit number to represent the materials in
 * * and a single character to represent the colors
 * 
 * Example: 0b => First material of the MATERIALs_ORDER and 11 color of the COLORS_ORDER
 * 
 * 
 * */

export class ShareLinkBuilderService {
    
    private static OLD_NUMBER_BASE = 32
    private static NEW_NUMBER_BASE = 36
    private static CURRENT_VERSION = "v2"

    private baseUrl: string
    constructor(baseUrl: string) {
      this.baseUrl = baseUrl
    }
    build(colors: {[key: string]: ColorMaterialInformation}): string  {
        const tmp: string[] = []
        parts.PARTS_ORDER.forEach((part) => {
            const indexInColorOrder = COLOR_ORDER.indexOf(colors[part].color as Color)
            const indexInMaterialOrder = MATERIALS_ORDER.indexOf(colors[part].material as Material)
            if (indexInMaterialOrder < 0 || indexInColorOrder < 0) {
              Honeybadger.notify("ShareLinkBuilderService.build:",part, colors[part])
            }

            tmp.push(`${indexInMaterialOrder}${(indexInColorOrder).toString(ShareLinkBuilderService.NEW_NUMBER_BASE)}`)
        })
        return `${this.baseUrl}?s=${ShareLinkBuilderService.CURRENT_VERSION}:${tmp.join(";")}`
    }

    static extractFromLink(link: string): {[key: string]: ColorMaterialInformation} {
      const decodedLink = decodeURIComponent(link)
      if (decodedLink.startsWith("v2:")) {
        const encodedParts = link.slice(3).split(";")
        const colors: {[key: string]: ColorMaterialInformation} = {}
        parts.PARTS_ORDER.forEach((part, index) => {
          const colorIndex = parseInt(encodedParts[index].substring(1), this.NEW_NUMBER_BASE)
          const materialIndex = parseInt(encodedParts[index].substring(0,1))

          colors[part] = {
            color: COLOR_ORDER[colorIndex],
            material: MATERIALS_ORDER[materialIndex]
          }
        })
        return colors
      } else {
        // old sharelink format
        const encodedColors = link.split('')
        const colors: {[key: string]: ColorMaterialInformation} = {}
        parts.PARTS_ORDER.forEach((part, index) => {
            const colorIndex = parseInt(encodedColors[index], this.OLD_NUMBER_BASE)
            colors[part] = {
              color: COLOR_ORDER[colorIndex],
              material: parts.getDefaultMaterialForComponent(part)
            }
        })
        return colors
      }
    }
}
